import { render } from "./enAttente.vue?vue&type=template&id=97c06dfc&scoped=true"
import script from "./enAttente.vue?vue&type=script&lang=js"
export * from "./enAttente.vue?vue&type=script&lang=js"

import "./enAttente.vue?vue&type=style&index=0&id=97c06dfc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97c06dfc"]])

export default __exports__